// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9c937a{background:rgba(0,0,0,.34);top:0;right:0;bottom:0;left:0;position:fixed;will-change:opacity;z-index:98;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}._9c937a._0626de,._9c937a.acb8c5{transition:opacity .15s}._9c937a._3e437c,._9c937a.acb8c5{opacity:0}", ""]);
// Exports
exports.locals = {
	"overlay": "_9c937a",
	"entering": "_0626de",
	"exiting": "acb8c5",
	"exited": "_3e437c"
};
module.exports = exports;
